const HCPAssignmentMode = Object.freeze({
    ASSIGNMENT: 0,
    VERIFICATION: 1,
    REASSIGNMENT: 2
})

export default HCPAssignmentMode